export const PAGE_EVENTS = {
  PAGE_LOAD: 'pageLoad',
  PAGE_UNLOAD: 'pageUnload',
  PAGE_UPDATE: 'pageUpdate',
};
